export const generateFlowQueryConnectionLineStyle = (colorTheme) => ({
  stroke: colorTheme.text,
  strokeWidth: 3,
  strokeDasharray: '10,4',
});

export const flowQueryDefaultEdgeOptions = {
  type: 'custom',
};
